module.exports = __webpack_public_path__ + "img/icon1.bbe7a209.png";